'use strict';

import minicart from './minicart';
import util from './util';
import menuCrosssell from './../js/pages/menu-crosssell';

Foundation.Keyboard.register('DropdownMenu', {
    'ENTER': 'submit'
});

function handleHeaderTopNotification () {
    if ($('#nars-header-slider').length) {
        const numberofmessage = $('.nars-header-banner').length;
        const singleMessage = $('.nars-header-banner a');
        const count = singleMessage.text().length;
        if(util.isMobile()) {
            if (numberofmessage > 1) {
                $('#nars-header-slider .nars-header-banner a').each(function () {
                    if($(this).text().length > 49) {
                       $(this).addClass('small-font');
                    } else {
                        $(this).removeClass('small-font');
                    }
                })
            } else {
                if (count > 49) {
                    singleMessage.addClass('small-font');
                } else {
                    singleMessage.removeClass('small-font');
                }
            }
        }
    } else {
        $('#minimized-header-container').addClass('without-top-banner');
    }
}

$(window).on('resize', function() {
    handleHeaderTopNotification();
});

function getVisibleItems($container, $items) {
    const containerRect = $container[0].getBoundingClientRect();
    let visibleIndexes = [];

    $items.each(function (index) {
        let rect = this.getBoundingClientRect();
        let isVisible = rect.right > containerRect.left && rect.left < containerRect.right;

        if (isVisible) {
            visibleIndexes.push(index);
        }
    });
    return visibleIndexes;
}

let previousAnnouncement = '';
function updateLiveRegion($container, $items, $liveRegion) {
    let visible = getVisibleItems($container, $items);

    if (!visible.length) return;

    let first = visible[0] + 1;
    let last = visible[visible.length - 1] + 1;
    let total = $items.length;
    let message = Resources.QUICK_ACCESS_SHOWING_ITEMS + ' ' + first + ' ' + Resources.QUICK_ACCESS_TO + ' ' + last + ' ' + Resources.QUICK_ACCESS_OF + ' ' + total;
    
    if (message !== previousAnnouncement) {
        previousAnnouncement = message;
        $liveRegion.text('');
        setTimeout(function () {
            $liveRegion.text(message);
        }, 50);
    }
}

export default {
    init : function () {
        handleHeaderTopNotification();
        $(document).ready(function () {
            const $container = $('.plps-container');
            if (!$container.length) {
                return;
            }
            const $items = $container.find('a');
            let $liveRegion = $('#plps-status');
    
            $items.each(function (index) {
                let text = $.trim($(this).text());
                $(this).attr('aria-label', text + ', '+ Resources.QUICK_ACCESS_ITEMS + ' ' + (index + 1) + ' ' + Resources.QUICK_ACCESS_OF + ' ' + $items.length);
            });
    
            updateLiveRegion($container, $items, $liveRegion);
            $container.on('scroll', function () {
                updateLiveRegion($container, $items, $liveRegion);
            });
            $(window).on('resize', function () {
                updateLiveRegion($container, $items, $liveRegion);
            });
        });
    
        if($(window).width() < 768) {
            $('.main-nav .level-2-link.active').removeClass('active').find('.level-3,.level-4').addClass('hide');
        }
    
        $('.menu-utility-user .contact, .menu-utility-user .newsletter').hover(function () {
            $(this).find('.menu-utility-content').show();
        });
        
        // 'tap' doesn't work as expected so using touchstart instead
        $(document).on('touchstart',function(e){
            // the tapped element
            var $target = $(e.target);
            
            // check if it's not the menu or the dropdown itself
            if($target.closest('.dropdown-menu').length == 0){
                // check if some dropdown menu is open, otherwise foundation will return an error 
                if($('.dropdown-pane.is-open').length){
                    $('.dropdown-pane.is-open').foundation('close');
                }
            }
        });
    
        $('a.utility-link').hover(function(evt) {
            evt.preventDefault();
            minicart.close(0); 
            $('.menu-utility-content').show();
        });
        
        $('.header-promotion-bar .promotion a').click(function(e) {
            e.preventDefault();
            var $headerPromotionBar = $(this).closest('.header-promotion-bar').find('.expanded-promotion-bar');		
            if($headerPromotionBar && $headerPromotionBar.length > 0){
                $(this).closest('.header-promotion-bar').addClass('expanded');
            } else{
                return false;
            }
        });
        $('.header-promotion-bar .icon-close').click(function(e) {
            e.preventDefault();
            $(this).closest('.header-promotion-bar').removeClass('expanded');
        });	
        
        $(document).mouseup(function (e) {
            var headerslots = $('.header-promotion-bar'); // YOUR CONTAINER SELECTOR
            
            if (!headerslots.is(e.target) // if the target of the click isn't the container...
            && headerslots.has(e.target).length === 0) // ... nor a descendant of the container
            {
                headerslots.removeClass('expanded');
            }
        });
    
        // overwrite foundation Enter key event 
        $('.menu-utility-user input').each(function(i, input){
            var $input = $(input);
            
            // overwrite only on input type text, email and password
            if($input.attr('type') == 'text' 
                || $input.attr('type') == 'email' 
                    || $input.attr('type') == 'password'){
                
                $input.keydown(function(e) {
                    Foundation.Keyboard.handleKey(e, 'DropdownMenu', {		
                        submit: function () {
                            var $form = $input.closest('form');
                            
                            // simulate blur event to check if it has error or not
                            $input.blur();
                            
                            // prevent submit if there are errors
                            if($form.find('span.error').length == 0){
                                
                                // $form.submit() doesn't work on login so it has to be this *sigh*
                                $form.find('button[type="submit"]').click();
                            }
                        }
                    });
                });
            }		
        });
    
        $('#navigation .show-more-links').on('click', function() {
            var $level1 = $(this).closest('.level-1');
            $level1.toggleClass('active');
        });
    
        $('#navigation .level-1 .link-extra').on('click', function() {
            var $level1 = $(this).closest('.level-1');
            $level1.removeClass('active');
        });
    
        $('.top-banner .level-1 li.tabEnabled > a').on('mouseover touchstart', function () {
            var $this = $(this).closest('li');
            $this.closest('.level-1.active').removeClass('active');
    
            $this.find('.level-2.hide').removeClass('hide');
            $this.find('.level-2-link').find('.level-3,.level-4').addClass('hide');
            $this.find('.level-2-link.active').removeClass('active');
            $this.find('.level-2-link').first().addClass('active').find('.level-3,.level-4').removeClass('hide');
            
            $('.right-search a.search.open').click();
            
            //lazyloading of the first flyout image
            var dataSrcFlyout = $this.find('.level-3 .flyoutimage img').attr('data-src');		
            $this.find('.level-2-link').first().find('.level-3 .flyoutimage img.replacesrc').attr('src', dataSrcFlyout);
            menuCrosssell.init();
        });
        
        $('.top-banner .level-1 li.tabDisabled > a').on('mouseover touchstart', function () {
            var $this = $(this).closest('li');
            $this.closest('.level-1.active').removeClass('active');
            
            $this.find('.level-2-link').find('.level-3').removeClass('hide');
            $this.find('.level-2.hide').removeClass('hide');
            if($this.find('.level-2-link .level-3').length === 0){
                $this.find('.level-cats').addClass('nothirdlevelmenu');
            }
            if($this.find('.level-2 .content-column').length === 0){
                $this.find('.level-cats').addClass('fullWidth');
            }
            $('.right-search a.search.open').click();
            //lazyloading of the Hero image
            var dataSrcFlyout,
                heroImgEleWrapper = $this.find('.level-2 .nav-banner');
            
            heroImgEleWrapper.each(function(i,ele) {
                var heroImgEle = $(ele).find('img.replacesrc');
                dataSrcFlyout = heroImgEle.attr('data-src');
                heroImgEle.attr('src', dataSrcFlyout);
            });
            menuCrosssell.init();
        });
    
        //click for second level menu
        $('.top-banner .tabEnabled .level-2-link').on('click mouseover', function () {
            $('.level-2-link').find('.level-3,.level-4').addClass('hide');
            $('.level-2-link.active').removeClass('active');		
            $(this).addClass('active').find('.level-3,.level-4').removeClass('hide');
            
            //lazyloading of flyout images
            var dataSrcFlyout = $(this).find('.level-3 .flyoutimage img').attr('data-src');		
            $(this).find('.level-3 .flyoutimage img.replacesrc').attr('src', dataSrcFlyout);
        });
        
        $(document).on('click' , '.folder-content-list .artist-tile .artist-mini-detail-link' , function(){
            var $artistTile = $(this).closest('.artist-tile');
            $('.artist-tile .artist-description').removeClass('artist-description-open');
            $artistTile.find('.artist-description').addClass('artist-description-open');		
        });
        
        $('.top-banner .level-1 .has-sub-menu').on('click mouseover', function () {
            var dataSrcFlyout = $(this).find('.level-2 .flyoutimage img').attr('data-src');		
            $(this).find('.level-2 .flyoutimage img.replacesrc').attr('src', dataSrcFlyout);
        });
        
        //Block to handle View All Link 
        $(window).on('load resize', function(){
            handleViewAllLinkPos();
        });
        
        function handleViewAllLinkPos(){
            var $level2LinkCont = $('.top-banner .tabEnabled .level-2');
            var maxHeightVal = 174;
            if($(window).width() <= 1024) {
                maxHeightVal = 150;
            }
            $level2LinkCont.css({'display':'block','visibility':'hidden'});
            $('.top-banner .tabEnabled .level-4:not(.level-2-second-column)').each(function(index) {
                var $viewAllLink = $(this).parent().next('.viewall-sm');
                if($(this).outerHeight() > maxHeightVal) {
                    $viewAllLink.addClass('viewAllMoveToRight');
                } else {
                    if($viewAllLink.hasClass('viewAllMoveToRight')) {
                        $viewAllLink.removeClass('viewAllMoveToRight');
                    }
                }
            });
            $level2LinkCont.removeAttr('style');
        }
    
    }, 
    updateMainMargin : function () {
    (function () {// IIFE to avoid polluting global scope
        // Function to update the margin-top of the main wrapper based on the header height
        const siteNewWrapper = document.querySelector('.js-margin-top');
        const siteHeader = document.querySelector('#minimized-header-container');
        const siteMainWrapper = siteNewWrapper != null ? siteNewWrapper : document.querySelector('#main');

        function updateMainMargin() {
            if (siteHeader && siteMainWrapper) {
                siteMainWrapper.style.marginTop = siteHeader.offsetHeight + 'px';
            }
        }

        // Initial set
        updateMainMargin();

        // Update on resize
        window.addEventListener('resize', updateMainMargin);
        window.addEventListener('load', updateMainMargin);
    })();
    }
}